export default __webpack_public_path__ + "static/media/icon_documents_pressed..3aaf75ab.svg";